import { $myFetch } from "."
import { Roles } from "../../utils"

export const $getSupplierParameters = (role: Roles): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "supplierparameters",
    {
      headers: myHeaders
    },
    [],
    role
  )
}
